// extracted by mini-css-extract-plugin
module.exports = {"contact":"ContactUs_contact__1RWY2","title":"ContactUs_title__2X5JD","text":"ContactUs_text__yHqko"};